import { Headline, Text } from "@volumental/common";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";

interface SurveyTitleProps {
  showDescription: boolean;
}
export function SurveyTitle({ showDescription }: SurveyTitleProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <div>
      <Headline className="text-xl leading-normal font-normal">{t("hybrid.surveyTitle")}</Headline>
      {Boolean(showDescription) && <Text>{t("hybrid.surveyDescription")}</Text>}
    </div>
  );
}
